import { STRINGS } from 'config';

const {
  SUMMARISER: { HOST },
} = STRINGS;

export async function getTranscriptionToken(selectedPracticeId: string) {
  const response = await fetch(`${HOST}/transcription/token?practiceId=${selectedPracticeId}`, {
    method: 'GET',
    credentials: 'include',
  });
  const json = await response.json();
  return json.jwt;
}
